import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import ProspectCallRequest from "./prospectcallRequests";
import InvestorCallRequest from "./investorcallRequest";
import PurchaseCalls from "./purchaseCalls";
import WealthCalls from "./wealthCalls";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

function TabsCallRequest() {
  const classes = useStyles();
  // let match = useRouteMatch();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let tabsList = [
    {
      name: "Prospects Calls",
      child: ProspectCallRequest,
    },
    {
      name: "Investors Calls",
      child: InvestorCallRequest,
    },
    {
      name: "Purchase Calls",
      child: PurchaseCalls,
    },
    {
      name: "Wealth",
      child: WealthCalls,
    },
  ];

  return (
    <div className={(classes.root, "pb30")}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          indicatorColor="primary"
          textColor="primary"
          TabIndicatorProps={{ style: { display: "none" } }}
        >
          {tabsList.map((text, index) => (
            <Tab
              label={text.name}
              key={index}
              {...a11yProps(index)}
              style={{ borderRadius: 20 }}
            />
          ))}
        </Tabs>
      </AppBar>
      {tabsList.map((object, index) => {
        return (
          <TabPanel value={value} index={index} key={"tab" + index}>
            {React.createElement(object.child, object.props)}
          </TabPanel>
        );
      })}
    </div>
  );
}
export default TabsCallRequest;
